import axios from 'axios';
import { take, call, fork, put } from 'redux-saga/effects';
import FormData from 'form-data';

import {
  GET_LOADING_IMAGE,
  UPLOAD_IMAGE_REQUEST,
} from '../../actions/uploadImage/constants';
import { setTemporaryImage } from '../../actions/uploadImage';

import { getImage, getLoadingImage } from '../api/uploadImage';

export function* getLoadingImageFlow() {
  while (true) {
    yield take(GET_LOADING_IMAGE);
    yield call(getLoadingImage);
  }
}

export function* uploadImageFlow() {
  while (true) {
    const request = yield take(UPLOAD_IMAGE_REQUEST);
    $('#save-public-profile').prop('disabled', true);
    $('#save-public-profile').html('Loading...');
    $('.upload-img-spinner').removeClass('hide');
    $('.upload-img').addClass('hide');
    const { file } = request.payload.file;
    const data = yield call(getImage, { filename: file.name });
    const formData = new FormData();
    formData.append('key', data.key);
    formData.append('acl', data.acl);
    formData.append('AWSAccessKeyId', data.aws_access_key_id);
    formData.append('success_action_status', data.success_action_status);
    formData.append('Content-Type', data.content_type);
    formData.append('Cache-Control', data.cache_control);
    formData.append('policy', data.policy);
    formData.append('signature', data.signature);
    formData.append('file', file);
    try {
      // eslint-disable-next-line @typescript-eslint/no-loop-func
      axios.post(data.url, formData).then(() => {
        $('#save-public-profile').prop('disabled', false);
        $('#save-public-profile').html('Save');
        $('.upload-img-spinner').addClass('hide');
        $('.upload-img').removeClass('hide');
      });
    } finally {
      yield put(setTemporaryImage(data.fullUrl));
    }
  }
}

export default function* uploadImageSaga() {
  yield fork(getLoadingImageFlow);
  yield fork(uploadImageFlow);
}
